export default "__VITE_ASSET__e34742a0__"